module.exports = __webpack_public_path__ + "img/1_no.539bb0e6.svg";